<flx-resources-grid
  [tableDef]="tableColumnsDef"
  [items]="items()"
  [rowClickEnabled]="false"
  class="h-full"
  emptyMsg="No processes found."
/>
